import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { JWTserviceService } from './jwtservice.service';
import jwt_decode from 'jwt-decode';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

interface DecodedToken {
  exp: number; // Expiry time (in seconds since the epoch)
  iat: number; // Issued at time (in seconds since the epoch)
  [key: string]: any; // Other optional fields that may be present
}

@Injectable({
  providedIn: 'root'
})
export class IdealTimeOutService {

  private timeoutDuration = Number(sessionStorage.getItem("idle_minutes"))* 60000;

  private idleTimeout: any;

  constructor(private ngZone: NgZone, private router: Router, private JWTservice:JWTserviceService, private dialog: MatDialog) {
    this.resetTimer();

// Listen to user activity events like mousemove, keydown, etc.
    window.addEventListener('mousemove', () => this.resetTimer());
    window.addEventListener('keydown', () => this.resetTimer());
    window.addEventListener('click', () => this.resetTimer());
    setTimeout(() => {
      const Token = localStorage.getItem('bearer_token');
      if (Token) {
        this.getTokenDates(Token);
      }
    }, 2000);
  }
  resetTimer() {
    // Clear the existing timeout
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }
    // Set a new timeout
     this.ngZone.runOutsideAngular(() => {
      this.idleTimeout = setTimeout(() => this.onTimeout(), this.timeoutDuration);
    }); 
  }

  private onTimeout() {
    const token = localStorage.getItem('bearer_token');
    if (!token) {
      return;
    }
    // Log out the user or take any other action
    this.ngZone.run(() => {
       // Navigate to logout or any desired route
      this.dialog.open(ConfirmationDialogComponent, {
        width: '350px',
        data: { message: 'You have been logged out due to inactivity. Please log in again to continue.', okOnly: true, title: "Logged Out" }
      });
       this.router.navigate(['/app-home'], { skipLocationChange: true });
      // this.JWTservice.acquireToken();
    });
  }

  decodeToken(token: string): DecodedToken | null {
    if (!token) {
      return null;
    }
    try {
      const decodedToken: DecodedToken = jwt_decode(token);
      return decodedToken;
    } catch (error) {
      return null;
    }
  }

  // Convert epoch time to JavaScript Date
  convertEpochToDateTime(epoch: number): Date {
    return new Date(epoch * 1000); // multiply by 1000 to convert seconds to milliseconds
  }

  // Get the start and expiry date-time from the token
  getTokenDates(token: string) {
    if (!token) {
      return;
    }
    const decoded = this.decodeToken(token);

    if (!decoded) {
      return null;
    }

    const startDate = this.convertEpochToDateTime(decoded.iat);
    const expiryDate:any = this.convertEpochToDateTime(decoded.exp);
    const ExpiryTimestamp:number = expiryDate.getTime();  // Convert to milliseconds
    const oneMinutesInMs: number = 1 * 60 * 1000;  // 1 minute in milliseconds
    const currentTime = new Date().getTime();
    // Calculate the time difference between the current time and the Unix timestamp
    const timeDifference = ExpiryTimestamp - currentTime;
    // If the timestamp is in the future, set a timer for 50 minutes after the timestamp
    if (timeDifference > 0) {
      setTimeout(() => {
        this.JWTservice.acquireToken();
      }, timeDifference - oneMinutesInMs);
    // } else {
    //   // If the timestamp is in the past, calculate the remaining time until 50 minutes from that timestamp
    //   const remainingTime = oneMinutesInMs + Math.abs(timeDifference);

    //   if (remainingTime > 0) {
    //     setTimeout(() => {
    //       alert("50 minutes have passed since the given timestamp!");
    //     }, remainingTime);
    //   } else {
    //     // If more than 50 minutes have passed already, alert immediately
    //     alert("More than 50 minutes have already passed since the given timestamp.");
    //   }
    }
  }
}


